/**
 * Scale Patterns
 * @type {Array}
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = [{
    name: 'Major',
    pattern: [0, 2, 4, 5, 7, 9, 11, 12]
}, {
    name: 'Minor',
    pattern: [0, 2, 3, 5, 7, 8, 10, 12]
}, {
    name: 'Harmonic Minor',
    pattern: [0, 2, 3, 5, 7, 8, 9, 12]
}];
module.exports = exports['default'];